import { render, staticRenderFns } from "./searchProfile.vue?vue&type=template&id=a2858f5c"
import script from "./searchProfile.vue?vue&type=script&lang=js"
export * from "./searchProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports